<template>
  <v-btn icon flat small @click="goConsulta">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver consulta</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goConsulta () {
      this.$router.push({ name: 'detalleConsulta', params: { id: this.item.id } })
    }
  }
}
</script>
